import { HTMLStyledProps, styled } from '@/styled-system/jsx'

export interface ShortLogoProps extends HTMLStyledProps<'svg'> {}

export default function ShortRoundedLogo(props: ShortLogoProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='29'
      viewBox='0 0 25 28'
    >
      <defs>
        <clipPath id='clip1'>
          <path d='M0 .117h24.953v27.817H0zm0 0'></path>
        </clipPath>
        <linearGradient
          id='linear0'
          x1='0'
          x2='111.011'
          y1='62.11'
          y2='61.983'
          gradientTransform='scale(.23148 .2258)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='#E90083'></stop>
          <stop offset='1' stopColor='#FF6864'></stop>
        </linearGradient>
      </defs>
      <g clipPath='url(#clip1)'>
        <path
          fill='url(#linear0)'
          d='M38.496.633l-.512 3.058c-.21 1.262-1.351 2.188-2.683 2.188h-5.364l.512-3.059C30.66 1.56 31.801.633 33.133.633zM34 8.503h-4.504l-2.664 15.915c-.266 1.574 1.008 3.004 2.676 3.004h4.5l2.668-15.914c.261-1.574-1.008-3.004-2.676-3.004zM15.445.61H4.492L4.11 2.88c-.261 1.574 1.008 3 2.672 3h6.422c2.45 0 4.317 2.098 3.93 4.41-.387 2.3-2.457 3.988-4.89 3.988H4.507c-1.328 0-2.461.922-2.672 2.18L0 27.402h5.379c1.324 0 2.457-.922 2.664-2.175l.953-5.7h5.23c5.208 0 9.641-3.617 10.465-8.535C25.605 5.547 21.207.61 15.445.61zm80.649.02h-7.348c-.894 0-1.726.426-2.226 1.137L81.2 9.32l-2.571-6.96c-.383-1.036-1.402-1.727-2.55-1.727h-6.864l-3.985 23.77c-.261 1.57 1.008 3 2.676 3h4.504l2.43-14.505 1.32 3.579.559 1.511c.367.996 1.226 1.785 2.308 2 1.262.254 2.52-.258 3.215-1.242l1.598-2.27 2.52-3.578-2.43 14.504h5.39c1.32 0 2.442-.918 2.653-2.164L96.093.633zM63.883 6.336l.945-5.707H51.445c-4.933 0-9.133 3.43-9.914 8.086l-1.27 7.574c-.98 5.84 3.735 11.129 9.915 11.129 5.855 0 10.844-4.07 11.773-9.602l.27-1.613c.261-1.562-1-2.98-2.653-2.98h-7.82l-.691 4.12c-.098.595.379 1.13 1.008 1.13h.898c.625 0 1.105.535 1.008 1.129-.297 1.761-1.883 3.062-3.746 3.07-1.762.008-3.098-1.527-2.817-3.195l1.852-11.059c.308-1.836 2.015-3.168 3.984-3.063 1.5.082 2.645 1.325 2.645 2.762 0 .211.18.383.398.383h4.945c1.32 0 2.446-.922 2.653-2.168zM113.625.117h-5.543c-4.328 0-8.016 3.004-8.7 7.094l-2.066 12.328c-.738 4.406 2.82 8.395 7.485 8.395h5.543c4.324 0 8.011-3.004 8.695-7.094l2.066-12.324c.739-4.407-2.816-8.399-7.48-8.399zm-.2 8.399l-1.859 11.101c-.296 1.766-1.89 3.067-3.765 3.067-1.746 0-3.082-1.497-2.805-3.149l1.86-11.101c.296-1.77 1.89-3.07 3.765-3.07 1.746 0 3.082 1.5 2.805 3.152zm0 0'
        ></path>
      </g>
    </svg>
  )
}
